

import Vue from "vue";
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'


Vue.use(ToastPlugin, {
type: "text",
position: "middle",
time: 2000
});

Vue.use(LoadingPlugin);
Vue.component("cell", Cell);
Vue.component("group", Group);
Vue.prototype.$message = {
cancel(text) {
Vue.$vux.toast.show({
type: "cancel",
text: text
});
},
longTxt(text) {
Vue.$vux.toast.show({
type: "long text",
text: text
});
},
warn(text) {
Vue.$vux.toast.show({
type: "warn",
text: text
});
},
success(text) {
Vue.$vux.toast.show({
type: "success",
text: text
});
},
text(text) {
Vue.$vux.toast.show({
type: "text",
text: text
});
}
};
export default {
name: "app",
created() {},
mounted() {}
};
